<template>
  <div class="idx_wrapper">
    <div class="banner_wrap">
      <div class="b_cont">
        <div class="b_tit"></div>
        <div class="b_ss_wrap">
          <input type="text" v-model.trim="inputKeyWord" placeholder="请输入搜索关键字" class="ipt_txt"/>
          <button class="ss_btn" @click="toSearch">搜 索</button>
        </div>
        <div class="b_link">
          <span>热门搜索： </span>
          <a @click="clickHotWords(item.key)" v-for="(item,index) in hotWords" :key="index">{{item.key}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FormSelect, FormSelectAutoComplete } from "@/components/form/index.js";

const HOME_TITLE = require("@/assets/images/banner_text.png");

export default {
  components: {
    // FormSelect, FormSelectAutoComplete,
  },
  props: {
    typeList: {
      type: Array,
      default: function () {
        return [
          {
            name: "按关键字",
            placeholder: "政策/项目/通知/公示",
            searchName: "搜 索",
            value: "sortByKeyWord",
          },
          {
            name: "按企业",
            placeholder: "企业名称，进行政策匹配",
            searchName: "匹 配",
            value: "sortByCompany",
          },
        ];
      },
    },
  },
  data() {
    return {
      hotWords:[
        {
          key:"政策",
        },
        {
          key:"教育",
        },
        {
          key:"求职",
        },
        {
          key:"税务",
        },
      ],
      flag: false,
      searchType: "sortByKeyWord", // 搜索类型{'sortByKeyWord':按关键字, 'sortByCompany':按企业}
      tyshxydm: "", // 企业统一社会信用代码
      companyData: [], // 企业列表
      inputKeyWord: "",
      searchSelect: "按关键字",
      typeIndex: 0, // 0按关键字 1按企业
      showType: {},
      tipsList: [], // 热搜词
      enterpriseData: [],
      selectEnterprise: null, // 选择的社会信用代码的item
      selectValue: "1",
      options: [
        {
          value: "1",
          label: "全部",
        },
        {
          value: "2",
          label: "政策库",
        },
        {
          value: "3",
          label: "企业办事库",
        },
        // {
        //   value: "4",
        //   label: "一件事一次办",
        // },
        // {
        //   value: "5",
        //   label: "政策项目",
        // },
        {
          value: "6",
          label: "通知公告",
        },
      ],
    };
  },
  computed: {
    cpu_homeTitleSrc() {
      return HOME_TITLE;
    },
  },
  created() {
    this.showType = this.typeList[0];
    this.getHotWords();
    if(sessionStorage.getItem("menuIndex")){
      this.selectValue = sessionStorage.getItem("menuIndex");
    }
  },
  mounted() {
    // let self = this;
    // let count = 5000
    // setInterval(function () {
    //     self.fade(self.flag)
    // }, count);
    // setTimeout(()=>{
    //     count=count+5000
    // },5000)
  },
  methods: {
    clickHotWords(word){
      this.inputKeyWord = word;
    },
    // 文字淡入淡出
    fade(flag) {
      if (flag) {
        this.$nextTick(() => {
          if (document.getElementById("bannertxt1")) {
            document.getElementById("bannertxt1").className = "fade";
          }
          if (document.getElementById("bannertxt2")) {
            document.getElementById("bannertxt2").className = "test";
          }
        });
      } else {
        this.$nextTick(() => {
          if (document.getElementById("bannertxt1")) {
            document.getElementById("bannertxt1").className = "test";
          }
          if (document.getElementById("bannertxt2")) {
            document.getElementById("bannertxt2").className = "fade";
          }
        });
      }
      this.flag = !this.flag;
    },
    /**
     * @description: 联想企业
     * @param {String} keyword 搜索关键字
     * @param {Function} cb 回调函数
     */
    searchComponay(keyword, cb) {
      let url = "/dev-api/elasticMgr/getEnterpriseDatas";
      let params = {
        pageNum: 1,
        pageSize: 10,
        keyWords: keyword,
      };
      this.companyData = [];
      this.$httpApi
        .get(url, params)
        .then((res) => {
          console.log("queryCompany:", res);
          if (res.code == 200) {
            this.companyData = (res.data || []).map((cv) => {
              return {
                ...cv,
                label: cv.name.replace(/<[^<>]+>/g, ""),
              };
            });
            cb(res.data || []);
          } else {
            cb([]);
          }
        })
        .catch((err) => {
          console.log("queryCompany error:", err);
          cb([]);
        });
    },
    getHotWords() {
      this.$httpApi
        .get("/dev-api/system/hotWords", {})
        .then((res) => {
          if (res.code == 200) {
            let list = res.rows;
            if (list.length === 0) {
              return;
            }
            if (list.length <= 3) {
              this.tipsList = list || [];
            } else {
              this.tipsList = [list[0], list[1], list[2]];
            }
          }
        })
        .catch((err) => {});
    },
    querySearchAsync(queryString, cb) {
      this.queryStringEnterprise(queryString, cb);
    },
    queryStringEnterprise(queryString, cb) {
      this.enterpriseData = [];
      let url = `/dev-api/cfgpermitconfig/query/data/find/cfg_permitinfo_andzchx_list`;
      let params = {
        keyword: queryString,
        itemtype: "2",
        release: "1",
        ["PAGE_CUR"]: "1",
        ["PAGE_ROWS"]: "",
      };
      this.$httpApi
        .post(url, params)
        .then((res) => {
          let result = [];
          let list = res.data;
          this.enterpriseData = list;
          for (const i in list) {
            let name = list[i].dept_name;
            //   let n1 = name.replace(/<\/?.+?>/g, "");
            //   let n2 = n1.replace(/ /g, "");
            // n2 += `(${list[i].shxydm})`;
            list[i].title = name;
            result.push({ value: name });
          }
          if (result.length > 0) {
            cb(result);
          } else {
            cb([{ value: "暂无数据" }]);
          }
        })
        .catch((err) => {});
    },
    // 选择autocomplete下拉选项
    handleSelect(item) {
      this.inputKeyWord = item.value;
      if (this.typeIndex == 1) {
        for (const i in this.enterpriseData) {
          const element = this.enterpriseData[i];
          if (item.value === element.title) {
            console.log("选择的", element);
            this.selectEnterprise = element;
          }
        }
      }
      this.gotoSearchResult();
    },
    /* 开始搜索 */
    toSearch() {
      // sessionStorage.setItem(
      //     "titleTypeBack",
      //     sessionStorage.getItem("titleType")
      //   );
      // sessionStorage.setItem("titleType", "1");
      if (this.typeIndex == 1) {
        this.queryStringEnterprise(this.inputKeyWord, () => {});
      } else {
        this.gotoSearchResult();
      }
    },
    /* 热搜词转跳 */
    tipTo(e) {
      this.inputKeyWord = e.word;
      this.gotoSearchResult();
    },
    gotoSearchResult() {
      // if (this.inputKeyWord.trim().length == 0) {
      //   this.$message({
      //     type: "warning",
      //     message: "请输入您要搜索的内容",
      //   });
      //   return;
      // }
      if (this.typeIndex == 0) {
        let params = {
          keyWords: this.inputKeyWord,
          type: this.typeList[this.typeIndex].value,
        };
        sessionStorage.setItem("searchData", JSON.stringify(params));
        this.$router.push({
          name: "searchList",
          params: { keyWords: this.inputKeyWord },
        });
        this.inputKeyWord = "";
      } else {
        if (this.selectEnterprise == null || this.selectEnterprise.id == null) {
          this.$message({
            type: "error",
            message: "企业信息错误, 请重新输入",
          });
          return;
        }
        let params = {
          keyWords: this.inputKeyWord,
          type: this.typeList[this.typeIndex].value,
          selectEnterprise: this.selectEnterprise,
        };
        sessionStorage.setItem("searchCompanyData", JSON.stringify(params));
        let { href } = this.$router.resolve({
          // path: "/policyMatch",
          name: "searchCompany",
          query: params,
        });
        window.open(href);
        this.inputKeyWord = "";
      }
    },
    selectChange(val) {
      sessionStorage.setItem("menuIndex", val);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/newStyle/css/idx.scss";
@import "@/assets/newStyle/css/login.scss";

</style>
